var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScience = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Lab-Bottle-Experiment--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Lab Bottle Experiment Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 7.46a0.49 0.49 0 0 1 -0.26 0.43A6.44 6.44 0 0 0 9.3 13.5a6.5 6.5 0 1 0 9.75 -5.61 0.48 0.48 0 0 1 -0.25 -0.43v-1a0.5 0.5 0 0 1 0.5 -0.5h1a1 1 0 0 0 0 -2h-1a0.5 0.5 0 0 1 -0.5 -0.5v-2A1.5 1.5 0 0 0 17.3 0h-3a1.5 1.5 0 0 0 -1.5 1.5v2a0.51 0.51 0 0 1 -0.51 0.5h-1.58a0.52 0.52 0 0 1 -0.41 -0.21 0.54 0.54 0 0 1 -0.06 -0.46 1 1 0 0 0 -1.89 -0.66L1.82 21.34A2 2 0 0 0 3.7 24h13.5a1 1 0 1 0 0 -2H4.41a0.51 0.51 0 0 1 -0.41 -0.21 0.5 0.5 0 0 1 -0.06 -0.46L9.07 6.67A1 1 0 0 1 10 6h2.28a0.51 0.51 0 0 1 0.51 0.5Zm0.5 7.29a0.75 0.75 0 1 1 0.75 -0.75 0.75 0.75 0 0 1 -0.75 0.75Zm2.75 2.5a0.75 0.75 0 1 1 0.75 -0.75 0.75 0.75 0 0 1 -0.75 0.75Zm2.25 -1.81a1.25 1.25 0 1 1 1.25 -1.25 1.25 1.25 0 0 1 -1.25 1.25ZM14.8 2.5a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0.5 0.5v1a0.5 0.5 0 0 1 -0.5 0.5h-1a0.5 0.5 0 0 1 -0.5 -0.5ZM16.3 6a0.5 0.5 0 0 1 0.5 0.5v1.9a1 1 0 0 0 0.63 0.93 4.54 4.54 0 0 1 2.47 2.32 0.29 0.29 0 0 1 0 0.24 0.26 0.26 0 0 1 -0.21 0.11h-7.77a0.26 0.26 0 0 1 -0.21 -0.11 0.25 0.25 0 0 1 0 -0.24 4.48 4.48 0 0 1 2.46 -2.32 1 1 0 0 0 0.64 -0.93V6.5a0.5 0.5 0 0 1 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScience);
export default ForwardRef;